<template>
  <div>
    <!-- Commission percentage -->
    <v-text-field
      id="commission_percentage"
      :label="$t('screener.admin.company.commission_percentage.title')"
      name="commission_percentage"
      type="text"
      :rules="[rules.inBetween(0, 100, company.commission_percentage)]"
      v-model="company.commission_percentage"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="greyDarken3--text body-1">
            {{ $t('screener.admin.company.commission_percentage.tooltip') }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <!-- Max Allowed Seats -->
    <v-text-field
      id="max_allowed_seats"
      :label="$t('screener.admin.company.max_seats.title')"
      name="max_allowed_seats"
      type="text"
      :rules="[
        rules.inBetween(
          DEFINES.PREMIUM_SCREENING_MIN_SEATS,
          DEFINES.PREMIUM_SCREENING_MAX_SEATS,
          company.max_allowed_seats,
        ),
      ]"
      v-model="company.max_allowed_seats"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="greyDarken3--text body-1">
            {{ $t('screener.admin.company.max_seats.tooltip') }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <!-- Enterprise Pricing -->
    <v-switch
      v-model="company.is_screening_pricing_enterprise"
      :label="'Flat / Enterprise Pricing'"
      color="saPrimary"
      @change="handleEnterpriseSwitcher"
    ></v-switch>
    <ConfirmationDialogBox
      :title="enterpriseDialog.title"
      :dialog="enterpriseDialog.visible"
      :yesBtnText="enterpriseDialog.yesBtnText"
      :noBtnText="enterpriseDialog.noBtnText"
      @confirm="handleConfirmation(enterpriseDialog.action)"
      @cancel="resetEnterpriseDialog"
    >
      <div v-if="enterpriseDialog.content && enterpriseDialog.content.length">
        <div class="subheading greyDarken1--text mb-2">
          <b>{{ $t('remember.title') }}</b>
        </div>
        <ul class="px-3" v-for="item in enterpriseDialog.content" :key="item">
          <li>
            <p class="mb-2 subheading greyDarken3--text">{{ item }}</p>
          </li>
        </ul>
      </div>
    </ConfirmationDialogBox>
  </div>
</template>

<script>
import i18n from '@/i18n';
import rules from '@/validation';
import DEFINES from '@/defines';

import ConfirmationDialogBox from '@/components/dialogBox/DynamicConfirmationBox';

export default {
  name: 'AdminCompanyProfileEnterprise',
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules,
      enterpriseDialog: {
        visible: false,
        title: null,
        yesBtnText: null,
        noBtnText: null,
        content: null,
        action: null,
      },
    };
  },
  components: {
    ConfirmationDialogBox,
  },
  watch: {
    company: {
      handler: function() {
        this.$emit('update:company', this.company);
      },
      deep: true,
    },
  },
  methods: {
    handleEnterpriseSwitcher(value) {
      if (value) {
        this.openEnterpriseDialog(
          i18n.t('enterprise.pricing.dialog.enable.title'),
          i18n.t('enable.btn.title'),
          i18n.t('rms.button.cancel'),
          DEFINES.ENTERPRISE_PRICING_WARNINGS.ENABLE,
          'enableEnterprisePricing',
        );
      } else {
        this.openEnterpriseDialog(
          i18n.t('enterprise.pricing.dialog.disable.title'),
          i18n.t('disable.btn.title'),
          i18n.t('rms.button.cancel'),
          DEFINES.ENTERPRISE_PRICING_WARNINGS.DISABLE,
          'disableEnterprisePricing',
        );
      }
    },
    openEnterpriseDialog(title, yesBtnText, noBtnText, content, action) {
      this.enterpriseDialog.visible = true;
      this.enterpriseDialog.title = title;
      this.enterpriseDialog.yesBtnText = yesBtnText;
      this.enterpriseDialog.noBtnText = noBtnText;
      this.enterpriseDialog.content = content;
      this.enterpriseDialog.action = action;
    },
    resetEnterpriseDialog() {
      this.enterpriseDialog.visible = false;
      this.enterpriseDialog.title = null;
      this.enterpriseDialog.yesBtnText = null;
      this.enterpriseDialog.noBtnText = null;
      this.enterpriseDialog.content = null;
      this.enterpriseDialog.action = null;
      this.company.is_screening_pricing_enterprise = !this.company
        .is_screening_pricing_enterprise;
    },
    handleConfirmation(handlerName) {
      this[handlerName]();
    },
    enableEnterprisePricing() {
      this.company.is_screening_pricing_enterprise = true;
      this.enterpriseDialog.visible = false;
    },
    disableEnterprisePricing() {
      this.company.is_screening_pricing_enterprise = false;
      this.enterpriseDialog.visible = false;
    },
  },
};
</script>

<style></style>
